module.exports = __webpack_public_path__ + "public/img/syb2x.52c1fad0.png";